<template>
  <div id="app">
    <router-view/>    
  </div>
</template>

<script>
export default {
}
</script>
<style lang="scss">
// <h1> color is Pink
// <p> color is GreyWhite
// <*> is box-sizing: border-box;
// <a> color is Blue 
// <a> padding was a bit added 
// Default Retro Design is under

// if you want Green, You should use --- color:#00ff1e;

.body, *{
  margin: 0;
  padding: 0;
}
*{
  font-family: Comic Sans MS;
  font-weight: 500;
  -webkit-font-smoothing: none;
  box-sizing: border-box;
}
h1{
  color: rgb(207, 112, 255);
}
p{
  color: rgb(202, 198, 190);
  font-weight: 400;
}
a, button{
  cursor: pointer;
}
a{
  /* Google Dark */
  // color: rgb(110, 155, 244);
  /* Marval */
  color: #1200f4;
  padding: 2px 6px;  
}
a:hover{
  color: rgb(207, 112, 255);
}
span{
  display: inline-block;
}
// Retro config ----
.grey--btn{
  background: #adadad;
}
.grey-border {
  border-color: #cbcbcb #4e474e #4e474e #cbcbcb;
  border-style: solid;
  border-width: 5px;
}
.grey-border-inner {
  outline: 2px solid #151514;
  border: 1px solid #b1b1af;
}
.blue-border{
  outline: 2px solid #1200f4;
  background: #adadad;
  // border: 2px solid #cbcbcb;
  border-color: #cbcbcb #4e474e #4e474e #cbcbcb;
  border-style: solid;
  border-width: 2px;
  padding: 2px 6px;
}

</style>
